import { render } from "./addItem.vue?vue&type=template&id=1b536a66&scoped=true&ts=true"
import script from "./addItem.vue?vue&type=script&lang=ts"
export * from "./addItem.vue?vue&type=script&lang=ts"

import "./addItem.vue?vue&type=style&index=0&id=1b536a66&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b536a66"]])

export default __exports__